import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconFile = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9z" />
    <path d="M14 3v6h6" />
  </SidebarIconSvg>
);

SidebarIconFile.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconFile;
